<template>
  <div id="flag-col">
    <div class="mt-2 img-flag--container">
      <img v-if="imgSrc" :src="imgSrc" class="rounded" border="1" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("enterpriseVesselList");

export default {
  name: "CellRendererCountryFlags",
  data() {
    return {
      imgSrc: null,
      val: this.params,
    };
  },
  computed: {
    ...mapGetters(["getCountryAlpha2"]),
  },
  created() {
    if (this.params.data.country_code.id) {
      let countryAlpha2 = this.getCountryAlpha2(
        this.params.data.country_code.id
      );
      this.imgSrc = countryAlpha2
        ? require(`@/assets/images/flags/${countryAlpha2}.svg`)
        : null;
    }
  },
};
</script>

<style lang="scss" scoped>
#flag-col {
  .img-flag--container {
    img {
      border: 1px #e2e2e2 solid;
    }
    width: 44px;
    height: 44px;
  }
}
</style>
